import { globalTypes } from "reducers/types/global";
import { getLimitDate } from "util/date";
import * as configUtils from "util/config";

export const types = {
    REQUEST_RULES_LIST: "echeqRules/REQUEST_RULES_LIST",
    SUCCESS_RULES_LIST: "echeqRules/SUCCESS_RULES_LIST",
    FAILED_RULES_LIST: "echeqRules/FAILED_RULES_LIST",
    REQUEST_RULE_ACTION_PRE: "echeqRules/REQUEST_RULE_ACTION_PRE",
    SUCCESS_RULE_ACTION_PRE: "echeqRules/SUCCESS_RULE_ACTION_PRE",
    FAILED_RULE_ACTION_PRE: "echeqRules/FAILED_RULE_ACTION_PRE",
    SUCCESS_RULE_ACTION_REORDER: "echeqRules/SUCCESS_RULE_ACTION_REORDER",
    SET_REMEMBERED_VALUES: "echeqRules/SET_REMEMBERED_VALUES",
};

export const INITIAL_STATE = {
    fetchingList: false,
    fetchingErrors: false,
    rules: [],
    rulesPagination: {
        pageNumber: null,
        totalPages: null,
    },
    filters: {
        "actives.inactives": {
            status: { value: "ALL", label: "Todos" },
            action: { value: "ALL", label: "Todos" },
            // TODO: Problema con fecha por defecto
            creationDates: [null, null],
            name: "",
            issuer: [],
            orderBy: "date",
            direction: "descendent",
        },
        "deleted.modified": {
            status: { value: "ALL", label: "Todos" },
            action: { value: "ALL", label: "Todos" },
            creationDates: [getLimitDate(-1, new Date(), "months").toDate(), getLimitDate(0).toDate()],
            name: "",
            issuer: [],
            orderBy: "date",
            direction: "descendent",
        },
    },
    isDesktop: true,
    summarySelectedRule: {},
    errorsPagination: {
        pageNumber: null,
        totalPages: null,
    },
    activeSection: "actives.inactives",
    orderingRules: false,
    rememberedValues: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        rules,
        totalPages,
        pageNumber,
        processText,
        isDesktop,
        summarySelectedRule,
        conditions,
        subConditionsAmount,
        subConditionsIssuer,
        subConditionsReceived,
        echeqsWithError,
        errorsPagination,
        activeSection,
        filters,
        rememberedValues,
    } = action;

    switch (action.type) {
        case globalTypes.RESET_SELECTED_ELEMENTS:
            return { ...INITIAL_STATE, serverSearchDate: state.serverSearchDate };
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        case types.REQUEST_RULES_LIST:
            return {
                ...state,
                fetchingList: true,
            };
        case types.SUCCESS_RULES_LIST:
            return {
                ...state,
                rules: isDesktop || pageNumber === 1 ? rules : [...state.rules, ...rules],
                rulesPagination: { totalPages, pageNumber },
                fetchingList: false,
                processText,
                conditions,
                subConditionsAmount,
                subConditionsIssuer,
                subConditionsReceived,
                activeSection,
                filters: {
                    ...state.filters,
                    [activeSection]: filters,
                },
            };
        case types.FAILED_RULES_LIST:
            return {
                ...state,
                fetchingList: false,
            };
        case types.REQUEST_RULE_ACTION_PRE:
            return {
                ...state,
                summarySelectedRule,
                fetchingErrors: true,
                orderingRules:
                    configUtils.getBoolean("frontend.show.echeqRules.rulesPrioritization.functionalities", false) &&
                    summarySelectedRule?.action === "reorder",
            };
        case types.SUCCESS_RULE_ACTION_PRE: {
            let echeqsWithErrorArray = [];
            if (summarySelectedRule?.action === "seeErrors") {
                echeqsWithErrorArray =
                    isDesktop || errorsPagination?.pageNumber === 1
                        ? echeqsWithError
                        : [...state.echeqsWithError, ...echeqsWithError];
            }
            return {
                ...state,
                summarySelectedRule,
                errorsPagination,
                echeqsWithError: echeqsWithErrorArray,
                fetchingErrors: false,
            };
        }
        case types.SUCCESS_RULE_ACTION_REORDER:
            return {
                ...state,
                orderingRules: false,
            };
        case types.SET_REMEMBERED_VALUES:
            return {
                ...state,
                rememberedValues,
            };
        default:
            return state;
    }
};

export const actions = {
    requestRulesList: (filters, isDesktop) => ({
        type: types.REQUEST_RULES_LIST,
        filters,
        isDesktop,
    }),
    ruleSummaryAction: (summarySelectedRule, pageNumber = 1, isDesktop) => ({
        type: types.REQUEST_RULE_ACTION_PRE,
        summarySelectedRule,
        pageNumber,
        isDesktop,
    }),
    setRememberedValues: (rememberedValues) => ({
        type: types.SET_REMEMBERED_VALUES,
        rememberedValues,
    }),
};

export const selectors = {
    getFetchingList: ({ echeqRules }) => echeqRules.fetchingList,
    getRuleList: ({ echeqRules }) => echeqRules.rules,
    getRulePagination: ({ echeqRules }) => echeqRules.rulesPagination,
    getProcessText: ({ echeqRules }) => echeqRules.processText,
    getSummarySelectedRule: ({ echeqRules }) => echeqRules.summarySelectedRule,
    getConditions: ({ echeqRules }) => echeqRules.conditions,
    getSubConditionsAmount: ({ echeqRules }) => echeqRules.subConditionsAmount,
    getSubConditionsIssuer: ({ echeqRules }) => echeqRules.subConditionsIssuer,
    getSubConditionsReceived: ({ echeqRules }) => echeqRules.subConditionsReceived,
    getEcheqsWithError: ({ echeqRules }) => echeqRules.echeqsWithError,
    getFetchingErrors: ({ echeqRules }) => echeqRules.fetchingErrors,
    getErrorsPagination: ({ echeqRules }) => echeqRules.errorsPagination,
    getActiveSection: ({ echeqRules }) => echeqRules.activeSection,
    getFilters: ({ echeqRules }) => echeqRules.filters,
    getOrderingRules: ({ echeqRules }) => echeqRules.orderingRules,
    getRememberedValues: ({ echeqRules }) => echeqRules.rememberedValues,
};
